import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { pageUrl } from '../actions/helpers';
import { getRemovedTokenList } from '../actions/api';
import { setRemovedTokenList, setALLPaginationParamsForRemoved } from '../actions/localStates';

import RemovedTokenSearchView from '../components/RemovedTokenSearchView'

class RemovedTokenSearchContainer extends Component {

	constructor(props) {
        super(props);

        this.search = this.search.bind(this);
        this.refresh = this.refresh.bind(this);
    }


	componentDidMount() {

	}

	search () {
        var searchParams = {
            "uri": this.props.search.uri,
            "removingDateTimeNotBefore": this.props.search.removingDateTimeNotBefore,
            "removingDateTimeNotAfter": this.props.search.removingDateTimeNotAfter,
            "ownerId": this.props.search.ownerId,
            "removingInitiatorId": this.props.search.removingInitiatorId,
            "operator": this.props.search.operator
        }

        var params = {
            size: this.props.page.size
        }

        var urlParams = this.props.actions.pageUrl(params)

        this.props.actions.getRemovedTokenList(this.props.base.serviceUrl, urlParams, searchParams, this.props.login.accessToken)
        .then((response) => {

            this.props.actions.setRemovedTokenList(response.content)
            this.props.actions.setALLPaginationParamsForRemoved(response.page)

            console.log(response)
        });
    }

	refresh () {
        var searchParams = {
            "uri": null,
            "removingDateTimeNotBefore": null,
            "removingDateTimeNotAfter": null,
            "ownerId": null,
            "removingInitiatorId": null,
            "operator": null
        }

        this.props.actions.getRemovedTokenList(this.props.base.serviceUrl, "", searchParams, this.props.login.accessToken)
        .then((response) => {

            this.props.actions.setRemovedTokenList(response.content)
            this.props.actions.setALLPaginationParamsForRemoved(response.page)

            console.log(response)
        });
    }

	render() {
		return (
			<RemovedTokenSearchView searchToken={this.search} refresh={this.refresh} />
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        search: state.removedTokenSearchReducer,
        login: state.loginReducer,
        page: state.removedPaginationReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
	    pageUrl, setRemovedTokenList, setALLPaginationParamsForRemoved,
        getRemovedTokenList
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(RemovedTokenSearchContainer);